import { CheckboxInput } from "@nova/component-checkbox-input"
import classNames from "classnames"
import { useWorkspacePermissions } from "features/data-management/workspace/useWorkspacePermissions"
import { TableHeader } from "features/data-management/workspace/tables/TableHeader"

export const UsersTableHeaders = ({
    primaryKey,
    handleAllMembersSelect,
    setFilterKeys,
}: {
    primaryKey: string
    handleAllMembersSelect: (checked: boolean) => void
    setFilterKeys: (keys: {
        primaryKey: string
        secondaryKey: string
        sortDirection: "asc" | "desc"
    }) => void
}) => {
    const { isAdmin } = useWorkspacePermissions()

    return (
        <thead className="text-left bg-gray-700 text-nova-gray-100">
            <tr>
                <th
                    className={classNames(
                        "pl-5 pr-3 py-[0.313rem]",
                        "max-w-[0.938rem] sticky top-0 z-10 bg-gray-700"
                    )}
                >
                    {isAdmin && (
                        <CheckboxInput
                            id="select-all-members"
                            onChange={handleAllMembersSelect}
                            isSmall
                        />
                    )}
                </th>
                <TableHeader
                    primaryKey={primaryKey}
                    headerKey={"fullName"}
                    title="USER"
                    setSearchDirection={(direction) =>
                        setFilterKeys({
                            primaryKey: "fullName",
                            secondaryKey: "fullName",
                            sortDirection: direction,
                        })
                    }
                />
                <TableHeader
                    primaryKey={primaryKey}
                    headerKey={"licenseOrder"}
                    title="LICENSE"
                    setSearchDirection={(direction) =>
                        setFilterKeys({
                            primaryKey: "licenseOrder",
                            secondaryKey: "fullName",
                            sortDirection: direction,
                        })
                    }
                    isDefault
                />
                <TableHeader
                    primaryKey={primaryKey}
                    headerKey={"pluginOrder"}
                    title="PAID ADD-ONS"
                    setSearchDirection={(direction) =>
                        setFilterKeys({
                            primaryKey: "pluginOrder",
                            secondaryKey: "fullName",
                            sortDirection: direction,
                        })
                    }
                />
                <TableHeader
                    primaryKey={primaryKey}
                    headerKey={"access"}
                    title="WORKSPACE ACCESS"
                    setSearchDirection={(direction) =>
                        setFilterKeys({
                            primaryKey: "access",
                            secondaryKey: "fullName",
                            sortDirection: direction,
                        })
                    }
                />
            </tr>
        </thead>
    )
}
